import { render, staticRenderFns } from "./LineupAcheteursList.vue?vue&type=template&id=0fb872b2&scoped=true&"
import script from "./LineupAcheteursList.vue?vue&type=script&lang=ts&"
export * from "./LineupAcheteursList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb872b2",
  null
  
)

export default component.exports